import React from "react";
import { KEY_BOARD } from "../../../constant/common";
import i18n from "../../../locale/i18n";
import { classNames } from "../../../utils";
import Icon from "../Icon";
import CheckedIcon from "./CheckedIcon";
import UnCheckIcon from "./UnCheckIcon";

export default function QuadrataSquareCheckbox({ selected, onSelect, className }) {
  const handleOnKeyDown = e => {
    switch (e.key) {
      case KEY_BOARD.SPACE:
      case KEY_BOARD.ENTER:
        if (onSelect) onSelect();
        break;
      default:
        break;
    }
  };
  return (
    <div
      className={classNames("quadrata-square-checkbox", className, { selected })}
      onClick={() => onSelect()}
    >
      <Icon
        role="checkbox"
        aria-checked={selected}
        aria-label={i18n.translate("dividendChecked")}
        onKeyDown={handleOnKeyDown}
        tabIndex="0"
        className="icon"
        name={selected ? "checkbox-active" : "checkbox"}
        children={selected ? <CheckedIcon /> : <UnCheckIcon />}
      />
      <p>{i18n.translate("dividendChecked")}</p>
    </div>
  );
}
